import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageRequest } from 'src/app/common/modules/data-table.module/interfaces';
import { ApiResponse } from 'src/app/core/entities/api-response.entity/api-response';
import { ApiService } from 'src/app/core/services/api.service/api.service';
import { DoctorAppointmentBill } from 'src/app/entities/appointment-bill.entity';
import { EAppointmentState } from 'src/app/entities/appointment.entity';
import { DoctorAppointment, EPatientAppointmentStatus } from 'src/app/entities/appointment.entity/doctor-appointment.entity/doctor-appointment';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DoctorSecretaryAppointmentsService extends ApiService {
  bill(appointemntId: string): Observable<DoctorAppointmentBill> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/${appointemntId}/invoice`, { responseType: 'json' }).pipe(this.responsePipe);
  }
   all(pageRequest?: PageRequest, query?: { date?: Date, query?: string, dateDebut?: Date, dateFin?: Date }): Observable<Array<DoctorAppointment>> {
     let params = new HttpParams();


    if (pageRequest!.pageOffset) params = params.append('page', pageRequest!.pageOffset)
    if (pageRequest!.pageSize) params = params.append('size', pageRequest!.pageSize);
    if (pageRequest!.sort?.order) {

      let order = "ASC";
      if (pageRequest!.sort.order == "desc") {
        order = "DESC";
        const sortParam = `${pageRequest!.sort.key}`;

        params = params.append("sort", sortParam);
        params = params.append('direction', order)

      } else if (pageRequest!.sort.order == "asc") {
        order = "ASC";
        const sortParam = `${pageRequest!.sort.key}`;

        params = params.append("sort", sortParam);
        params = params.append('direction', order)

      }
    }


    if (query) {
      if (query.date) params = params.append('at', query.date.getTime());
      // Correction : "before" doit venir de dateFin, "after" doit venir de dateDebut
      if (query.dateDebut) params = params.append('after', query.dateDebut.getTime());
            if (query.dateFin) params = params.append('before', query.dateFin.getTime());

      if (query.query) params = params.append('q', query.query);
    }

    if (!query?.query)
      return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/timings`, { params: params, responseType: 'json' }).pipe<Array<DoctorAppointment>>(this.responsePipe);
    
    else return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/timings/search`, {params: params, responseType: 'json' }).pipe<Array<DoctorAppointment>>(this.responsePipe);
  }
 attente(pageRequest?: PageRequest, query?: { date?: Date, query?: string, dateDebut?: Date, dateFin?: Date }): Observable<Array<DoctorAppointment>> {
    let params = new HttpParams();


    if (pageRequest!.pageOffset) params = params.append('page', pageRequest!.pageOffset)
    if (pageRequest!.pageSize) params = params.append('size', pageRequest!.pageSize);
    if (pageRequest!.sort?.order) {

      let order = "ASC";
      if (pageRequest!.sort.order == "desc") {
        order = "DESC";
        const sortParam = `${pageRequest!.sort.key}`;

        params = params.append("sort", sortParam);
        params = params.append('direction', order)

      } else if (pageRequest!.sort.order == "asc") {
        order = "ASC";
        const sortParam = `${pageRequest!.sort.key}`;

        params = params.append("sort", sortParam);
        params = params.append('direction', order)

      }
    }


    if (query) {
      if (query.date) params = params.append('at', query.date.getTime());
      // Correction : "before" doit venir de dateFin, "after" doit venir de dateDebut
      if (query.dateDebut) params = params.append('after', query.dateDebut.getTime());
            if (query.dateFin) params = params.append('before', query.dateFin.getTime());

      if (query.query) params = params.append('q', query.query);
    }

    if (!query?.query)
      return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/timings/onhold`, { params: params, responseType: 'json' }).pipe<Array<DoctorAppointment>>(this.responsePipe);
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/timings/search/onhold`, { params: params, responseType: 'json' }).pipe<Array<DoctorAppointment>>(this.responsePipe);

  }
  countPendingAppointments(): Observable<number> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/timings/onhold/count`, { responseType: 'json' }).pipe<number>(this.responsePipe);
  }
  allRdvCalendar(before: number, after: number): Observable<Array<DoctorAppointment>> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/timings/all?before=${after}&after=${before}`, { responseType: 'json' }).pipe<Array<DoctorAppointment>>(this.responsePipe);
  }
  search(query: { date?: Date, query?: string }): Observable<Array<DoctorAppointment>> {
    let params = new HttpParams();
    if (query.date) params = params.append('date', query.date.getTime());
    if (query.query) params = params.append('query', query.query);
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/all/search`, { params: params, responseType: 'json' }).pipe<Array<DoctorAppointment>>(this.responsePipe);
  }

  timings(
  timings: { at?: number; before?: number; after?: number },
  pageRequest: PageRequest,
  query?: { date?: Date; query?: string; assistantId?: string }
): Observable<Array<DoctorAppointment>> {

  let params = new HttpParams();

  // =====================
  // TIMINGS
  // =====================
  if (timings?.at != null) params = params.set('at', timings.at);
  if (timings?.before != null) params = params.set('before', timings.before);
  if (timings?.after != null) params = params.set('after', timings.after);

  // =====================
  // PAGINATION
  // =====================
  if (pageRequest?.pageOffset != null) {
    params = params.set('page', pageRequest.pageOffset);
  }

  if (pageRequest?.pageSize != null) {
    params = params.set('size', pageRequest.pageSize);
  }

  // =====================
  // SORT
  // =====================
  if (pageRequest?.sort?.key && pageRequest?.sort?.order) {
    const order = pageRequest.sort.order === 'desc' ? 1 : 0;
    params = params.set('sort', `${pageRequest.sort.key},${order}`);
  }

  // =====================
  // SEARCH MODE
  // =====================
  const hasQuery =
    !!query?.query ||
    !!query?.date ||
    !!query?.assistantId;

  if (hasQuery) {

    if (query?.date) {
      params = params.set('at', query.date.getTime());
    }

    if (query?.query) {
      params = params.set('q', query.query);
    }

    if (query?.assistantId) {
      params = params.set('assistantId', query.assistantId);
    }

    return this.http.get<ApiResponse>(
      `${environment.API_URL}/doctor/secretary/appointments/timings/search`,
      { params, responseType: 'json' }
    ).pipe(this.responsePipe);
  }

  // =====================
  // DEFAULT MODE
  // =====================
  return this.http.get<ApiResponse>(
    `${environment.API_URL}/doctor/secretary/appointments/timings`,
    { params, responseType: 'json' }
  ).pipe(this.responsePipe);
}

  add(patientId: string, appointment: DoctorAppointment): Observable<DoctorAppointment> {
    return this.http.post<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments?patientId=${patientId}`, appointment.requestPayload, { responseType: 'json' }).pipe(this.responsePipe);
  }

  update(id: string, appointment: DoctorAppointment): Observable<DoctorAppointment> {
    return this.http.put<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/${id}`, appointment.requestPayload, { responseType: 'json' }).pipe(this.responsePipe)
  }

  getMotifs(idSpecialty: string): Observable<any> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/consultations/tags/motif/${idSpecialty}`).pipe(this.responsePipe)
  }

  one(appointmentId: string): Observable<DoctorAppointment> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/${appointmentId}`, { responseType: 'json' }).pipe<DoctorAppointment>(this.responsePipe);
  }

  updateStatus(appointmentId: string, status: EAppointmentState): Observable<DoctorAppointment> {
    return this.http.put<ApiResponse>(`${environment.API_URL}/doctor/secretary/appointments/${appointmentId}/status?status=${status}`, { responseType: 'json' }).pipe<DoctorAppointment>(this.responsePipe);
  }
    balance(patientId: string): Observable<number> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/patients/${patientId}/invoices/balance`).pipe(this.responsePipe)
  }

  historique(patientId: string, pageRequest?: PageRequest): Observable<Array<DoctorAppointment>> {
    let params = new HttpParams();

    if (pageRequest) {
      if (pageRequest.pageOffset) params = params.append('page', pageRequest.pageOffset);
      if (pageRequest.pageSize) params = params.append('size', pageRequest.pageSize);
    }

    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/patients/${patientId}/appointments`, { params, responseType: 'json' }).pipe<Array<DoctorAppointment>>(this.responsePipe);
  }
  updatePatientStatus(
  appointmentId: string,
  patientAppointmentStatus: EPatientAppointmentStatus
  
): Observable<DoctorAppointment> {

  const body = {
    patientAppointmentStatus: patientAppointmentStatus.trim()
  };

  return this.http.patch<ApiResponse>(
    `${environment.API_URL}/doctor/secretary/appointments/${appointmentId}/patient-status`,
    body,
    { responseType: 'json' }
  ).pipe<DoctorAppointment>(this.responsePipe);
}
}
